module.exports = __webpack_public_path__ + "static/media/level6.40ecef0d.svg";